import styled from "styled-components";

export const Container = styled.div`
	display: flex;

	width: 100%;
	height: 100%;

	background-color: #f5f5f5;

	font-family: "Mulish";

	padding: 1rem;
`;

export const Content = styled.div`
	width: 100%;
	height: 100%;

	overflow: auto;

	padding: 1rem;

	.header {
		display: flex;

		align-items: flex-start;
		justify-content: space-between;

		width: 100%;
		height: 20%;

		padding: 0 1.5rem;

		p {
			font-size: 1.2rem;
			font-weight: 600;
		}
	}
	#func {
		color: #252733;
	}

	#name,
	#keep-title {
		color: #2d7bbc;
	}

	.process-manager {
		margin-left: 1.5rem;
	}

	#process-title {
		color: #3751ff;
	}

	#ErrorProcess-title {
		color: #990000;
	}

	#ApprovedProcess-title {
		color: #ffa800;
	}
	#FinalProcess-title {
		color: #2bde53;
	}

	#PendingProcess-title {
		color: #ffa800;
	}

	#process-title,
	#ErrorProcess-title,
	#PendingProcess-title,
	#keep-title,
	#FinalProcess-title,
	#ApprovedProcess-title {
		font-size: 1.2rem;
		font-weight: 600;

		margin-top: 1rem;
	}

	.send-icon {
		cursor: pointer;
		border: none;
	}

	.func-name,
	.header-manager {
		display: flex;

		align-items: flex-start;
		gap: 0.5rem;
	}

	.header-manager {
		padding-right: 2rem;
		gap: 2rem;
	}

	.table-container {
		width: 100%;
		height: 25vh;

		padding: 0.25rem 0 0.25rem 0;

		background-color: white;

		border-radius: 0.25rem;
	}

	.table-wrapper {
		width: 100%;
		height: 100%;

		overflow: auto;
	}

	tbody {
		height: 100%;

		overflow: auto;

		padding-right: 0.5rem;
	}

	tr,
	th,
	td {
		display: flex;

		align-items: center;
		justify-content: center;
	}

	tr {
		width: 100%;
		min-height: 3.5rem;

		font-size: 0.9rem;

		border-bottom: #dfe0eb 1px solid;
		border-radius: 0rem;

		white-space: nowrap;

		color: black;

		text-decoration: none;
	}

	th,
	td {
		position: relative;

		width: 12.5%;
		height: 2rem;

		font-size: 1rem;

		margin-left: 0.5rem;

		font-size: 1rem;

		margin-left: 0.5rem;

		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.get-in-form {
		width: 5rem;
		height: 2rem;

		border-radius: 0.25rem;
		border: none;

		cursor: pointer;

		background-color: #2d7bbc;

		transition: 0.35s;

		a {
			text-decoration: none;

			color: white;

			font-weight: 600;
		}
	}

	#prop-name {
		overflow: hidden;
		text-overflow: ellipsis;

		justify-content: flex-start;
	}

	.buttons-ana {
		width: 8rem;
		height: 2rem;

		border: none;
		border-radius: 0.25rem;

		font-size: 1rem;
		font-weight: 600;

		transition: 0.4s;

		cursor: pointer;
	}

	#edit {
		color: #990000;

		background-color: rgba(153, 0, 0, 0.2);

		:hover {
			background-color: #990000;

			color: white;
		}
	}

	#final {
		color: #2bde53;

		background: rgba(43, 222, 83, 0.3);

		:hover {
			background: #2bde53;

			color: white;
		}
	}

	#disabled {
		color: #ffa800;

		background-color: rgba(255, 168, 0, 0.2);

		:hover {
			background-color: rgba(255, 168, 0, 1);

			color: white;
		}
	}

	.Search-container {
		display: flex;

		align-items: center;

		background-color: white;

		border-radius: 2rem;

		padding: 1rem;

		width: 25rem;
		height: 3rem;
	}

	#searchBox {
		border: none;

		margin-left: 0.2rem;

		width: 100%;
		height: 100%;

		background: none;
	}

	.ana-table,
	.error-table,
	.pending-table,
	.final-table {
		display: flex;
		flex-direction: column;

		gap: 1rem;

		.popup-finishing-process {
			position: fixed;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 30rem;
			height: 20rem;
			background-color: white;
			border-radius: 0.5rem;
			display: flex;
			z-index: 100;
			padding: 10px;
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: space-between;
			flex: 1;

			label {
				display: flex;
				flex-direction: column;
				height: 25%;
				width: 60%;
				align-content: center;
				justify-content: center;
				flex: 6;
				gap: 5px;
				font-size: 1.2rem;
				text-align: center;
			}

			.input-div {
				display: flex;
				flex-direction: column;

				width: 100%;
				height: 25%;

				align-items: center;
				justify-content: center;
			}

			.input-title {
				font-size: 1.2rem;
			}

			.input-content {
				width: 60%;
				height: 3rem;

				border: 1px solid #c0c4df;
				border-radius: 0.25rem;

				font-size: 1.2rem;

				padding-left: 0.25rem;
			}

			.send-container {
				display: flex;

				height: 25%;

				align-items: center;
				justify-content: center;
			}

			.send-caixa {
				border: none;
				background-color: #2d7bbc;
				flex: 1;
				color: white;
				padding: 0.5rem;
				cursor: pointer;
				justify-self: end;
				transition: all 0.2s;
				border-radius: 3px;
				font-size: 1.2rem;
				height: 3rem;
			}

			.send-caixa[disabled] {
				filter: opacity(0.2);
				cursor: not-allowed;
			}
		}
		.popup-shadow {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background-color: rgb(0, 0, 0, 0.2);
			z-index: 99;
		}
	}
`;
